import { QueryClient } from '@tanstack/react-query';
export function createReactQueryClient() {
  return new QueryClient();
}